module.exports = __webpack_public_path__ + "static/media/recipe_category_9.11040555.png";